module.exports = __webpack_public_path__ + "img/lg_ring_y_s_null_0@2x.3a783c8d.png";